import EnabledAddinCommands from '../store/schema/EnabledAddinCommands';
import extensibilityState from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export default action('setEnabledAddinCommands')(function setEnabledAddinCommands(
    enabledAddinCommands: EnabledAddinCommands
) {
    extensibilityState.EnabledAddinCommands = enabledAddinCommands;
});
